
interface listItem {
  appLink: string // '//www.baidu.com'
  brand: string // '大众'
  brandId: number // 1
  giftPrice: string // '5000'
  h5Link: string // '//www.baidu.com'
  maxDiscount: string // '12.97'
  minPrice: string // '11.79'
  newsEndTime: string // '有效期至2月28日'
  replaceDiscount: string // '1'
  serialGroupId: number // 11
  serialGroupName: string // '新宝骏RC-...' // 截字后车系名
  serialOriginalName: string // '新宝骏RC-5w' // 原始车系名
  sgPhotoSrc: string // 'http://img.pcauto.com.cn/images/upload/upc/tx/auto5/2102/18/c7/253920721_1613648517840.png'
  saleRank: string // '大型SUV销量第1' //销量标签
  rank: string // '大型SUV关注第2' //关注标签
  officialPrice: string // '50.98-77.98万' //官方指导价
  type: number // 0 //类型：0-优惠，1-试驾
}

import { defineComponent, reactive, toRefs, computed, ref, PropType } from 'vue'
import { useStore } from 'vuex'
import couponPopup from '@/components/common/popup/coupon-popup.vue'
import enrollSuccessPopup from '@/components/common/popup/enroll-success-popup.vue'
import customBtn from '@/components/common/btn/custom-btn.vue'
import { countAd } from '@/http/api'
export default defineComponent({
  name: '',
  components: { customBtn, couponPopup, enrollSuccessPopup },
  props: {
    list: {
      type: Array as PropType<listItem[]>,
      default() {
        return []
      },
    },
    noResult: {
      type: Number,
      default: 0,
    },
    recommendNoResult: {
      type: Number,
      default: 0,
    },
    isShowLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore()
    const itemRef = ref()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
      browserEnv: store.state.browserEnv,
      isShowPopup: false,
      enrollSgInfo: {},
      isShowSuccessPopup: false,
      successPopupType: 0,
    })
    const methods = {
      getOfficialPrice(priceStr: string) {
        if (priceStr === '暂无报价') {
          return priceStr
        } else {
          return priceStr.substring(0, priceStr.length - 1)
        }
      },
      // 触发提交弹窗
      toggleEnrollPopup(ishow: any, item: any = {}) {
        if (ishow === true) {
          countAd(6314)
        }
        data.isShowPopup = ishow
        data.enrollSgInfo = item
      },
      // 提交弹窗回调提交成功
      enrollSuccess(type: any) {
        methods.toggleEnrollSuccessPopup(true, type)
      },
      // 触发提交成功弹窗
      toggleEnrollSuccessPopup(isShow: boolean, type: any) {
        data.isShowSuccessPopup = isShow
        data.successPopupType = type
      },
      // 跳转车系页
      jumpToSerialPage(item: any) {
        countAd(6313)
        if (data.browserEnv === 1) {
          // app
          window.location.href = item.appLink
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          // h5浏览器 或 微信浏览器
          window.location.href = item.h5Link + '?ad=15082'
        }
      },
    }
    return {
      ...toRefs(data),
      ...methods,
      itemRef,
    }
  },
})
